/**
 * Created by luohao on 2019/6/12.
 */
import Vue from 'vue'
import Vuex from 'vuex'
import vehModel from './modules/vehModel'

Vue.use(Vuex)

const state = {
  fromApp: false
}
const getters = {
  getFromApp: state => {
    return state.fromApp
  }
}
const mutations = {
  setFromApp (state, payload) {
    state.fromApp = payload
  }
}
const actions = {}

export default new Vuex.Store({
  strict: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    vehModel
  }
})
